module.exports = __webpack_public_path__ + "img/45.689c208e.png";